/**
 * Created by Nikolai Gorte on 28.08.2018.
 */

import 'leaflet.vectorgrid/dist/Leaflet.VectorGrid';
import { PointSymbolizer } from './VectorSymbolizers/Symbolizer.Point';
import { LineSymbolizer } from './VectorSymbolizers/Symbolizer.Line';
import { FillSymbolizer } from './VectorSymbolizers/Symbolizer.Fill';

const vectorTileLayerStyles = {
    default: {
        weight: 2,
        radius: 4,
        fillColor: '#9bc2c4',
        fillOpacity: 0.4,
        fill: true
    }
};

const RemoteVectorLayer = L.VectorGrid.Protobuf.extend({

    initialize: function(url, options) {
        const { onClick, onMouseOver } = options;
        L.VectorGrid.Protobuf.prototype.initialize.call(this, url, {
            getFeatureId(feat) {
                return feat.properties.type + '_' + feat.properties.id;
            },
            vectorTileLayerStyles: {
                default: {
                    ...vectorTileLayerStyles.default,
                    ...options.style,
                }
            },
            ...options,
        });

        this.on('click', onClick);
        //this.on('mouseover', onMouseOver);
    },

    _createLayer: function(feat, pxPerExtent, layerStyle) {
        var layer;
        switch (feat.type) {
            case 1:
                layer = new PointSymbolizer(feat, pxPerExtent);
                break;
            case 2:
                layer = new LineSymbolizer(feat, pxPerExtent);
                break;
            case 3:
                layer = new FillSymbolizer(feat, pxPerExtent);
                break;
        }

        if (this.options.interactive) {
            layer.addEventParent(this);
        }

        return layer;
    },
});

export default RemoteVectorLayer;



// WEBPACK FOOTER //
// ./js/layer/RemoteVectorLayer.js